import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function getFunctionsList() {
    return axios.get(`${url}/func/list`)
        .then(response => {
            return {
                functionsList: response.data,
            };
        });
}

function getFunctionsListDescription(params) {
    const userId = params.user_id ? '/' + params.user_id : '';
    return axios.get(`${url}/func/list-description${userId}`)
        .then(response => {
            return {
                functionsListDescription: response.data,
            };
        });
}

function updateFunction(params) {
    const payload = params;
    const options = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    };
    return axios.post(`${url}/func/` + payload.id + `/update`, payload, options)
        .then(response => {
            return {
                updatedFunction: response.data
            };
        }).catch(err => {
            return {
                updatedFunction: err.response.data
            };
        });
}
function banFunctionForChosenUser(params) {
    const payload = params;

    return axios.post(`${url}/func/update/function_ban`, payload)
        .then(response => {
            return {
                banFunctionForChosenUser: response.data
            };
        }).catch(err => {
            return {
                banFunctionForChosenUser: err.response.data
            };
        });
}

export default {
    getFunctionsList,
    getFunctionsListDescription,
    updateFunction,
    banFunctionForChosenUser
};